/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2024.
 */

import { isNil } from 'lodash';
import { GetServerSidePropsContext } from 'next';

export const REQUEST_ID_HEADER_KEY = 'x-hcl-next-request-id';
export type AppContextWrapper = GetServerSidePropsContext & {
	isWrapper?: boolean;
	extra: Record<string, any>;
};
export const isAppContext = (context: GetServerSidePropsContext) =>
	!!(context as AppContextWrapper).isWrapper;

export const getRequestId = (ctx?: GetServerSidePropsContext) => {
	if (!isNil(ctx)) {
		if (isAppContext(ctx)) {
			return (ctx as any as AppContextWrapper).extra.requestId;
		} else {
			// req is optional chained in case `ctx` is DocumentContext
			return ctx.req?.headers[REQUEST_ID_HEADER_KEY];
		}
	} else {
		return undefined;
	}
};
